<template>
  <div class="vx-row">
    <div class="vx-col w-full lg:w-1/3 mb-base" v-show="$auth.checkRoles(bsgRoles.readers)">
     <vx-card  slot="no-body" :title="$t('KPU.MainTitle')" class="text-center greet-user mb-5" v-show="$auth.checkRoles(bsgRoles.readers)">
        <menu-control :items="editItems">
        </menu-control>
        <ul class="menu_line">
          <li>
            <div class="menu-icon bg-secondary">
              <feather-icon icon="HelpCircleIcon" svgClasses="text-white stroke-current w-5 h-5" />
            </div>
            <div class="menu-text">
              <a target="_blank" href="https://agnicoeagle.sharepoint.com/:p:/s/GRP_CSD_Data_Solution/EUhXa2lSRldIk5_1ORLcF8kBW2JyCvQlrWbWbjJMCrVAKg?e=RTIVxH">{{ $t('Documentation') }}</a>
            </div>
          </li>
        </ul>

      </vx-card>
    </div>
    <div class="vx-col w-full lg:w-1/3 mb-base" v-show="$auth.checkRoles(bsgRoles.admins)">
      <admin />
    </div>
  </div>
</template>
<script>

import bsgRoles from './roles.js'
import admin from './admin/components/admin.vue'
import menuControl from '@/app/shared/components/lists/menu.vue'

export default {
  components: {
    admin,
    menuControl
  },
  data() {
    return {
      bsgRoles,
      editItems : [ 
        {
          roles : bsgRoles.collaborators,
          icon : "BarChart2Icon",
          to : "/bsg/kpu/kpus",
          i18nTitle : "KPU.Title"
        },
        {
          roles : bsgRoles.readers,
          icon : "BarChart2Icon",
          to : "/bsg/kpu/report/kpu",
          i18nTitle : "KPU.Report"
        },
        {
          roles : bsgRoles.admins,
          icon : "FileTextIcon",
          to : "/bsg/kpu/report/paginatedkpu",
          i18nTitle : "KPU.PaginatedReport"
        }
      ]
    }
  }
};
</script>